import { render } from "./app-tag.vue?vue&type=template&id=18b6b598&ts=true"
import script from "./app-tag.vue?vue&type=script&lang=ts"
export * from "./app-tag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__